import { Collapse } from "@opten/collapse/initializer";
import { Component } from "@opten/compiler/metadata/component";
import { addClass } from "@opten/dom/add-class";
import { getParentWithClass } from "@opten/dom/get-parent-with-class";
import { removeClass } from "@opten/dom/remove-class";
import { debounce } from "@opten/reactive/debounce";

declare const Cookiebot: any;
declare const Swiper: any;

@Component({ className: "js-course" })
export class CourseComponent {
	private dates: HTMLElement[];
	private locations: HTMLInputElement[];
	private itemsWrapper: HTMLElement;

	private activeDate: Date;
	private contentId: string;
	private contentLocation: string;
	private boxed = false;

	private navbar: HTMLElement;

	private slider: HTMLElement;
	private sliderWrapper: HTMLElement;
	private swiper: any;
	private swiperWrapper: any;
	private shortCollapse: Collapse;
	private activeSlide = 0;

	constructor(private element: HTMLElement) {
		this.navbar = document.getElementsByClassName(
			"js-navbar-height"
		)[0] as HTMLElement;
		this.dates = Array.from(
			document.getElementsByClassName("js-course-date")
		) as HTMLElement[];
		this.locations = Array.from(
			document.querySelectorAll(".js-course-locations")
		) as HTMLInputElement[];
		this.itemsWrapper = document.getElementsByClassName(
			"js-course-items"
		)[0] as HTMLElement;
		this.slider = document.getElementsByClassName(
			"js-course-slider"
		)[0] as HTMLElement;
		this.sliderWrapper = document.getElementsByClassName(
			"js-course-slider-wrapper"
		)[0] as HTMLElement;

		const shortCollapseElem = document.getElementById(
			"calendar-current"
		) as HTMLElement;
		if (shortCollapseElem) {
			this.shortCollapse = Collapse.getInstance(shortCollapseElem);
		}

		this.activeDate = new Date(window.sessionStorage.getItem("activeDate"));
		if (
			!this.activeDate ||
			this.activeDate.getTime() === new Date(null).getTime()
		) {
			if (this.slider) {
				this.activeDate = this.getValidDate(
					this.slider.getAttribute("data-current-date")
				);
			} else {
				this.activeDate = this.getValidDate(
					this.itemsWrapper.getAttribute("data-date")
				);
			}
		}
		this.contentId = this.itemsWrapper.getAttribute("data-id");
		this.contentLocation = this.itemsWrapper.getAttribute("data-location");
		this.boxed = this.itemsWrapper.getAttribute("data-boxed") === "true";

		let wasActivated = false;
		this.dates.forEach((item, index) => {
			item.addEventListener("click", (e) => {
				e.preventDefault();
				this.shortCollapse?.show();
				this.activeSlide = index;
				this.activate(item);
			});
			const date = this.getValidDate(item.getAttribute("data-date"));
			if (
				wasActivated === false &&
				this.activeDate.getTime() === date.getTime()
			) {
				this.activeSlide = index;
				this.activate(item);
				wasActivated = true;
			}
		});

		if (this.locations && this.locations.length > 0) {
			this.locations.forEach((input) => {
				input.addEventListener("change", (e) => {
					this.loadItems();
					const fieldset = input.closest("fieldset");
					if (fieldset) {
						if (this.getLocationsValue() != "") {
							fieldset.classList.add("has-value");
						} else {
							fieldset.classList.remove("has-value");
						}
					}
				});
			});
		}

		if (wasActivated === false) {
			this.activeSlide = 0;
			this.activate(this.dates[0]);
			wasActivated = true;
		}

		this.initSlider();
	}

	private activate(item) {
		this.activeDate = this.getValidDate(item.getAttribute("data-date"));
		this.dates.forEach((elem) => {
			const date = this.getValidDate(elem.getAttribute("data-date"));
			if (this.activeDate.getTime() === date.getTime()) {
				addClass(elem, "is-active");
			} else {
				removeClass(elem, "is-active");
			}
		});
		if (this.swiperWrapper) {
			this.activeSlide =
				this.activeSlide % this.swiperWrapper.slides.length;
			this.swiper.slideTo(this.activeSlide, undefined, false);
			this.swiperWrapper.slideTo(this.activeSlide, undefined, false);
		}
		this.loadItems();
		window.sessionStorage.setItem(
			"activeDate",
			this.activeDate.toISOString()
		);
	}

	private loadItems() {
		if (this.sliderWrapper) {
			this.itemsWrapper =
				(this.sliderWrapper.querySelectorAll(".js-course-items")[
					this.activeSlide
				] as HTMLElement) || this.itemsWrapper;
		}

		var params =
			"id=" +
			this.contentId +
			"&date=" +
			this.activeDate.toISOString() +
			"&boxed=" +
			this.boxed;

		const locVal = this.getLocationsValue();
		if (locVal && locVal != "") {
			params = params += "&location=" + encodeURIComponent(locVal);
		}
		fetch("/umbraco/surface/" + this.contentLocation, {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"accept-language": document.documentElement.lang,
				"X-Requested-With": "XMLHttpRequest",
			},
			body: params,
			credentials: "include",
		})
			.then((response) => {
				const contentType = response.headers.get("content-type");
				if (contentType && contentType.includes("text/html")) {
					return response.text();
				}
			})
			.then((data) => {
				if (data != null && data.length > 0) {
					this.itemsWrapper.innerHTML = data;
				}
			});
	}

	private initSlider() {
		if (this.slider && this.sliderWrapper) {
			this.swiper = new Swiper(this.slider, {
				autoHeight: true,
				speed: 500,
				initialSlide: this.activeSlide,
				slidesPerView: 7,
				slidesPerGroup: 7,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			});
			this.swiperWrapper = new Swiper(this.sliderWrapper, {
				autoHeight: true,
				speed: 500,
				initialSlide: this.activeSlide,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
			});
			this.swiperWrapper.on("slideNextTransitionStart", () => {
				const nextSlide = this.getNextSibling(
					this.swiperWrapper.slides[this.swiperWrapper.previousIndex],
					":not(.swiper-slide-disabled)"
				);
				if (nextSlide) {
					this.activeSlide = Array.from(
						nextSlide.parentNode.children
					).indexOf(nextSlide);
				}
				this.activate(this.dates[this.activeSlide]);
			});
			this.swiperWrapper.on("slidePrevTransitionStart", () => {
				const prevSlide = this.getPreviousSibling(
					this.swiperWrapper.slides[this.swiperWrapper.previousIndex],
					":not(.swiper-slide-disabled)"
				);
				if (prevSlide) {
					this.activeSlide = Array.from(
						prevSlide.parentNode.children
					).indexOf(prevSlide);
				}
				this.activate(this.dates[this.activeSlide]);
			});

			const collapse = getParentWithClass(this.slider, "js-collapse");
			if (collapse) {
				collapse.addEventListener("shown.opten.collapse", () => {
					this.swiper.update();
				});
			}

			window.addEventListener(
				"resize",
				debounce(() => {
					this.swiper.updateAutoHeight(0);
					this.swiperWrapper.updateAutoHeight(0);
				}, 400)
			);
		}
	}

	private getPreviousSibling(elem, selector) {
		let sibling = elem.previousElementSibling;

		while (sibling) {
			if (sibling.matches(selector)) return sibling;
			sibling = sibling.previousElementSibling;
		}
	}

	private getNextSibling(elem, selector) {
		let sibling = elem.nextElementSibling;

		while (sibling) {
			if (sibling.matches(selector)) return sibling;
			sibling = sibling.nextElementSibling;
		}
	}

	private getValidDate(date: string): Date {
		return new Date(date.replace(/-/g, "/"));
	}

	private getLocationsValue(): string {
		if (!this.locations || this.locations.length === 0) return "";
		const vals = this.locations
			.filter((i) => (i as HTMLInputElement).checked)
			.map((i) => (i as HTMLInputElement).value)
			.filter((v) => v != null && v !== "");
		return vals.join(",");
	}
}
